module.exports = __webpack_public_path__ + "static/media/ABENT3.crop-twitter.14e12403.jpg";